var handle_array = ["genesis-adjustable-bases","adjustable-base-g2-massage","genesis-adjustable-bases-g3","genesis-adjustable-bases-g4","mlily-fusion-1000-hybrid-mattress-online-retail-price","mlily-sale-fusion-luxe-50-off-in-store-only","mlily-sale-fusion-supreme-50-off-in-store-only","mlily-harmony-60-off-summer-sale","mlily-serene-elite-60-off-summer-sale","mlily-serenity-60-off-summer-sale","mlily-theater-of-dreams-hybrid-mattress-manchester-united-online-retail-price","mlily-wellflex-1-0-call-for-additional-50-off-price","mlily-wellflex-2-0-call-for-additional-50-off-price"];
 var hide_price=0;
 var hide_ajaxaddtocart=1;
 var display_phone=1;
 var phone_no = '(941)922-2292';
 var display_call_for_price = 1;
 var call_for_price_label = 'CALL TO ORDER';
 var css_style_button='background-color: #1FC0A0;color:#ffffff; text-align:center;width: 150px; margin-left: 50%; transform: translateX(-50%);';
 var enabled_captcha = 0;
 var site_key = '';
 var thankyou_msg = 'Your Request Submitted Successfully.';
 var thankyou_header = 'Success';
 var name_label='Name';
 var email_label='Email';
 var phone_label = ' Phone Number';
 var comment_label = 'Comment';
 var submit_label ='Submit';
  var error_name_label='Please fill out this fields.';
 var error_email_label='Please fill out valid this fields.';
 var error_phone_label = 'Please fill out valid this fields.';
 var error_comment_label = 'Please fill out this fields.';
 var enable_app =1;
  var enable_outofstock = 1;
 var price_selector='.price-box';
 var cart_selector='.product__inside__info';
 var phone_no_label = 'Dial:';
 var required_field='name,email,comment';
 var contact_form_heading='Call for Price for';
 var parent_selector='';
 var unavailable_label='Unavailable';
